import React from "react";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";
import CircularProgressListSkeleton from "./CircularProgressListSkeleton";

const PastEventsDataSkeleton = ({ styles }) => {
  const deviceSize = useDeviceSize();
  let skeletonCards = Array(5).fill(0);
  return (
    <View
      style={[styles.deviceflexDirection, { justifyContent: "space-between" }]}
    >
      <View
        style={{
          width:
            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? "48%" : "100%",
          justifyContent: "center",
        }}
      >
        <View
          style={
            {
              // borderWidth: 1, borderColor: AppColors.white
            }
          }
        >
          <Skeletons
            height={284}
            width={"100%"}
            style={{
              borderRadius: 10,
              marginBottom: 10,
            }}
          />
        </View>
      </View>
      <View
        style={[
          {
            width:
              deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? "47%" : "100%",
            gap: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 40 : 20,
            flexDirection: "row",
          },
        ]}
      >
        <View style={{ alignItems: "center" }}>
          <View
            style={{
              // width:
              //   deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
              //     ? "auto"
              //     : "25%",
              gap: 20,
            }}
          >
            <View>
              <Skeletons
                height={15}
                width={"70px"}
                style={{
                  borderRadius: 10,
                }}
              />
              <Skeletons
                height={15}
                width={"70px"}
                style={{
                  borderRadius: 10,
                  marginTop: 10,
                }}
              />
            </View>
            <View
              style={{
                alignItems: "center",
                backgroundColor: AppColors.grayColor_282828,
                padding: 10,
                borderRadius: 8,
              }}
            >
              <Skeletons
                height={70}
                width={"57px"}
                style={{
                  borderRadius: 10,
                }}
              />
              <Skeletons
                height={15}
                width={"50px"}
                style={{ marginTop: 10, borderRadius: 10 }}
              />
            </View>

            <View style={{}}>
              <Skeletons
                height={32}
                width={"80px"}
                style={{ marginTop: 10, borderRadius: 10 }}
              />
            </View>
          </View>
        </View>
        <View style={{ flex: 1 }}>
          <View>
            <View
              style={{
                alignItems: "center",
              }}
            >
              <Skeletons
                height={15}
                width={"100px"}
                style={{
                  borderRadius: 10,
                }}
              />
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                gap: 5,
              }}
            >
              {skeletonCards.map((medal) => (
                <View key={medal.id} style={{ alignItems: "center" }}>
                  <Skeletons
                    height={40}
                    width={"40px"}
                    style={{
                      borderRadius: 10,
                      marginTop: 10,
                    }}
                  />
                  <Skeletons
                    height={10}
                    width={"15px"}
                    style={{
                      borderRadius: 10,
                      marginTop: 10,
                    }}
                  />
                  <Skeletons
                    height={10}
                    width={"25px"}
                    style={{
                      borderRadius: 10,
                      marginTop: 10,
                    }}
                  />
                </View>
              ))}
            </View>
          </View>
          <View
            style={{
              width: "100%",
            }}
          >
            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "space-evenly",
                marginTop: 40,
                gap: 30,
              }}
            >
              <Skeletons height={75} width={"75px"} style={{}} circle={true} />
              <Skeletons height={75} width={"75px"} style={{}} circle={true} />
              <Skeletons height={75} width={"75px"} style={{}} circle={true} />
            </View>
            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "space-evenly",
                marginTop: 20,
              }}
            >
              <Skeletons height={75} width={"75px"} style={{}} circle={true} />
              <Skeletons height={75} width={"75px"} style={{}} circle={true} />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default PastEventsDataSkeleton;
